module.exports = __webpack_public_path__ + "img/vertical_6_5_8011.1f3c30f6.png";